export const CREATE_TEMPLATE_CATEGORY = 'app/Templates/Admin/CREATE_TEMPLATE_CATEGORY';
export const CREATE_TEMPLATE_CATEGORY_SUCCESS = 'app/Templates/Admin/CREATE_TEMPLATE_CATEGORY_SUCCESS';
export const UPDATE_TEMPLATE_CATEGORY = 'app/Templates/Admin/UPDATE_TEMPLATE_CATEGORY';
